import { useCallback, useRef, useState } from 'react'

/**
 * Triggers a report refetch without changing filters, pagination, or sort state.
 * Add `refreshToken` to the report fetch effect dependency array and call
 * `refresh()` from the toolbar Refresh button.
 */
export function useReportRefresh(isLoading = false) {
  const [refreshToken, setRefreshToken] = useState(0)
  const refreshInFlightRef = useRef(false)

  const refresh = useCallback(() => {
    if (isLoading || refreshInFlightRef.current) return
    refreshInFlightRef.current = true
    setRefreshToken((token) => token + 1)
  }, [isLoading])

  const completeRefresh = useCallback(() => {
    refreshInFlightRef.current = false
  }, [])

  return { refreshToken, refresh, completeRefresh }
}
